import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getBrandWarehouse } from "../../../services/warehouse/Warehouse";
import { getBrandSearchLocality } from "../../../services/Locality/Locality";
import AdminMenu from "../../AdminMenu";

const LocalityView = () => {
  const navigate = useNavigate();
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [localityInfoData, setLocalityInfoData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  let enabledGarmentProcessStageBrand =
    brandProfileData.enabledGarmentProcessStage;
  const [loading, setLoading] = useState(false);

  const fetchBrandSearchLocality = (data) => {
    setLoading(true);
    getBrandSearchLocality(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setLocalityInfoData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  useEffect(() => {
    const data = {
      brandId: brandId,
      locality: "",
      city: "",
      state: "",
      pin: "",
    };
    fetchBrandSearchLocality(data);
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (text) => {
    setSearchTerm(text);
    handleSearch(text);
  };

  const handleSearch = async (text) => {
    if (text) {
      const data = {
        brandId: brandId,
        locality: text,
        city: "",
        state: "",
        pin: "",
      };
      fetchBrandSearchLocality(data);
    } else {
      const data = {
        brandId: brandId,
        locality: "",
        city: "",
        state: "",
        pin: "",
      };
      fetchBrandSearchLocality(data);
    }
  };

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div className="flex">
                    <img
                      src="warehouse/place.png"
                      alt="place"
                      style={{ width: 20 }}
                    />
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Locality :
                    </p>
                  </div>
                  <p className="text-lg font-medium capitalize">
                    {item.locality}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div className="flex">
                    <img
                      src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Store.png"
                      alt="place"
                      style={{ width: 20 }}
                    />
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      city :
                    </p>
                  </div>
                  <p className="text-lg font-medium capitalize">{item.city}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <div className="flex">
                      <img
                        src="warehouse/place.png"
                        alt="place"
                        style={{ width: 20 }}
                      />
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        state :
                      </p>
                    </div>
                    <p className="text-lg font-medium capitalize">
                      {item.state}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/LocalityCreate", {
                        state: {
                          item: item,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div className="flex">
                    <img
                      src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Store.png"
                      alt="place"
                      style={{ width: 20 }}
                    />
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Pin:
                    </p>
                  </div>

                  <p className="text-lg font-medium capitalize">{item.pin}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div className="flex">
                    <img
                      src="warehouse/place.png"
                      alt="place"
                      style={{ width: 20 }}
                    />
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Landmark :
                    </p>
                  </div>
                  <p className="text-lg font-medium capitalize">
                    {item.landmark}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div className="flex">
                    <img
                      src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Store.png"
                      alt="place"
                      style={{ width: 20 }}
                    />
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Latitude:
                    </p>
                  </div>

                  <p className="text-lg font-medium capitalize">
                    {item.latitude}
                  </p>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 2,
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div className="flex">
                    <img
                      src="warehouse/place.png"
                      alt="place"
                      style={{ width: 20 }}
                    />
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Longitude :
                    </p>
                  </div>
                  <p className="text-lg font-medium capitalize">
                    {item.longitude}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Locality
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2 mx-5 flex flex-1">
        <div
          onClick={() =>
            navigate("/LocalityCreate", {
              state: {
                item: null,
              },
            })
          }
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
        >
          <div>
            <img
              src={
                "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
              }
              style={{ width: 27 }}
            />
          </div>
        </div>
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search Locality"}
              value={searchTerm}
              onChange={(e) => handleChange(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        <div
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          onClick={() => setSearchTerm("")}
        >
          <div>
            <p className="text-4xl font-bold " style={{ color: "red" }}>
              X
            </p>
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : localityInfoData?.length > 0 ? (
          <div>
            <div>{renderCardItem(localityInfoData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Locality Data Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default LocalityView;
